/* eslint-disable no-unused-vars */
import React from "react";

export const currentDate = () => {
    const dateNow = new Date(); // Creating a new date object with the current date and time
    const year = dateNow.getFullYear(); // Getting current year from the created Date object
    const monthWithOffset = dateNow.getUTCMonth() + 1; // January is 0 by default in JS. Offsetting +1 to fix date for calendar.
    const month = // Setting current Month number from current Date object
    monthWithOffset.toString().length < 2 // Checking if month is < 10 and pre-prending 0 if not to adjust for date input.
        ? `0${monthWithOffset}`
        : monthWithOffset;
    const date =
    dateNow.getUTCDate().toString().length < 2 // Checking if date is < 10 and pre-prending 0 if not to adjust for date input.
        ? `0${dateNow.getUTCDate()}`
        : dateNow.getUTCDate();

    const materialDateInput = `${year}-${month}-${date}`; // combining to format for defaultValue or value attribute of material <TextField>
    return materialDateInput;
}
export default currentDate;

export const uniqueFormID = () => {
    return 'PBUKYC-' + (Math.random()*Date.now()).toString(36).substr(2, 6).toUpperCase();

}

/*export const uniqueServiceFormID=()=>{
    return 'PBUSR-' + (Math.random()*Date.now()).toString(36).substr(2, 6).toUpperCase();
}*/



// A Set to store generated IDs to ensure uniqueness
const generatedIdsSet = new Set();

export const uniqueServiceFormID = () => {
  const generateUniqueId = () => {
    // Prefix: Fixed at 6 characters
    const prefix = "PBUSR-";

    // Random Part: Generate 7 random characters
    const randomPart = Math.random().toString(36).substring(2, 9).toUpperCase(); // Always 7 chars

    // Timestamp Part: Generate 8 characters from a high-precision timestamp (remove decimals)
    const timestampPart = Math.floor(performance.now()).toString(36).substring(0, 8).toUpperCase();

    // Combine random and timestamp parts, and trim if necessary to make it 15 characters
    const uniqueId = `${prefix}${randomPart}${timestampPart}`.substring(0, 15);

    return uniqueId;
  };

  let newId = generateUniqueId();

  // Ensure the generated ID is unique
  while (generatedIdsSet.has(newId)) {
    newId = generateUniqueId();
  }

  // Add the new ID to the Set
  generatedIdsSet.add(newId);

  return newId;
};